import React, { useState } from 'react'
import { Dialog, IconButton, DialogTitle, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import './style.css'

export const DialogAssignedUsers = ({ open, setOpen, infoEmail, handleHabilitadoUsers }) => {
    const [users, setUsers] = useState(infoEmail?.users || [])

    const handleHabilitar = async (e, userId) => {
        const checked = e.target.checked
        console.log({ userId, checked })

        const newListUsers = users.map(user => {
            if (user.id === userId) {
                return {
                    ...user,
                    habilitado: checked
                }
            }

            return user

        })

        setUsers(newListUsers)
        await handleHabilitadoUsers(infoEmail.id, newListUsers)

    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>
                <h5 className="p-mayus-inicial mt-5">Reporte {infoEmail?.nombre || ''}</h5>
                <h6 style={{ color: 'gray' }}>Usuarios asignados</h6>
            </DialogTitle>

            <DialogContent>
                <div className="table-responsive">

                    <table className="table p-table-global">
                        <thead className='p-thead-global'>
                            <tr className="text-center p-tr-titles-global">
                                <th className='text-start'>Usuario</th>
                                <th className='text-center'>Habilitado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users?.map(user => (
                                <tr key={user.id} className='p-tr-body-global'>
                                    <td className="text-start" style={{ textTransform: 'uppercase' }}>
                                        {user.nombre}{' '}{user.apellidos}
                                    </td>
                                    <td className="text-center" style={{ textTransform: 'uppercase' }}>
                                        <input
                                            type="checkbox"
                                            checked={user?.habilitado || false}
                                            style={{ height: '17px', width: '17px', cursor: 'pointer' }}
                                            onChange={(e) => handleHabilitar(e, user.id)}
                                        />
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>

                </div>
            </DialogContent>

        </Dialog >
    )
}